import React, { useState, useEffect } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import { data, useNavigate } from "react-router-dom";
import Table from "../../components/Table";
import Input from "../../components/Input";
import ColorPicker from "../../components/ColorPicker";
import PopUp from "../../components/PopUp";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { Trash2, SquarePen, Plus } from "lucide-react";
import Combobox from "../../components/Combobox";

const RowPCC = ({ data }) => {
    return (
        <>
            <div className="grid grid-cols-3 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Descrizione}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DurataManutenzione}
                </div>
            </div>
        </>
    );
};

const RowPCS = ({ data }) => {
    return (
        <>
            <div className="grid grid-cols-2 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Colore} <span className="w-4 h-4 ml-2" style={{ backgroundColor: data.value.Colore }}></span>
                </div>
            </div>
        </>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && header.key !== '' && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <div className="flex items-center ml-1 text-sm">
                                {
                                    header.key === "Colore" ? (
                                        <>
                                            {data.value[header.key]} <span className="w-4 h-4 ml-2" style={{ backgroundColor: data.value.Colore }}></span>
                                        </>
                                    ) : (
                                        data.value[header.key]
                                    )
                                }
                            </div>
                        </div>
                    )
                ))
            }
        </>
    );
}

const CategorieStati = () => {
    const headersC = [
        { label: "Nome", key: "Nome" },
        { label: "Descrizione", key: "Descrizione" },
        { label: "Durata Manutenzione (mesi)", key: "DurataManutenzione" }
    ];
    const headersS = [
        { label: "Nome", key: "Nome" },
        { label: "Colore", key: "Colore" },
    ];
    const [macroC, setMacroC] = useState([]);
    const [selectedMacro, setSelectedMacro] = useState(null);
    const [categorie, setCategorie] = useState([])
    const [dataC, setDataC] = useState([]);
    const [dataS, setDataS] = useState([]);
    const [isRowCInfoVisible, setIsRowCInfoVisible] = useState(false);
    const [isAddCVisible, setIsAddCVisible] = useState(false);
    const [needConfirmRowC, setNeedConfirmRowC] = useState(false);
    const [dataRowC, setDataRowC] = useState(null);
    const [dataAddC, setDataAddC] = useState({
        "Nome": null,
        "Descrizione": null,
        "DurataManutenzione": null
    });
    const [isAddMacroVisible, setIsAddMacroVisible] = useState(false);
    const [nomeMacro, setNomeMacro] = useState(null);
    const [isRowSInfoVisible, setIsRowSInfoVisible] = useState(false);
    const [isAddSVisible, setIsAddSVisible] = useState(false);
    const [needConfirmRowS, setNeedConfirmRowS] = useState(false);
    const [dataRowS, setDataRowS] = useState(null);
    const [dataAddS, setDataAddS] = useState({
        "Nome": null,
        "Colore": null
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setDataC(categorie.filter(d => d.IDPadre === selectedMacro).map((d) => ({ value: d })))
    }, [selectedMacro])

    const onload = async () => {
        //getInfoUtente
        setIsLoading(true);
        try {

            await loadNav();

            //loadTipologie
            // const r2 = await fetch("/getTipologie", {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //     },
            //     body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
            // });

            const r2 = await fetch("/getCategorie", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate("/manager/dash"); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setMacroC(rd2.filter(d => d.IDPadre === null));
                setCategorie(rd2.filter(d => d.IDPadre !== null));
                if (document.cookie.indexOf("PreselectMacro") !== -1) {
                    const preselect = document.cookie.split("PreselectMacro=")[1].split(";")[0];
                    setSelectedMacro(Number(preselect));
                    // setDataC(rd2.filter(d => d.IDPadre !== null).filter(d => d.IDPadre === Number(preselect)).map((d) => ({ value: d })))
                }

                const r3 = await fetch("/getStati", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
                });

                const rd3 = await r3.json();

                if (r3.status === 500) {
                    console.log(rd3.error);
                    setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate("/manager/dash"); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setDataS(rd3.map((d) => ({ value: d })));
                }

            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento delle informazioni utente", onClose: () => { setShowAlert(false); navigate("/manager/dash"); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleEliminaC = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/eliminaCategoria', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], ID: dataRowC.value["ID"] })
                });

                if (response.status === 200) {
                    window.location.reload(true);
                }
                else {
                    const data = await response.json();
                    console.log(data.error);
                    setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Operazione fallita, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare questa categoria?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModificaC = async () => {
        if (!dataRowC.value["Nome"] || !dataRowC.value["DurataManutenzione"] || !dataRowC.value["IDPadre"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/aggiornaCategoria", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: dataRowC.value['ID'],
                    Nome: dataRowC.value['Nome'],
                    Descrizione: dataRowC.value['Descrizione'],
                    DurataManutenzione: dataRowC.value["DurataManutenzione"],
                    IDPadre: dataRowC.value["IDPadre"]
                }),
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload(true);
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica della categoria", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpAddC = async () => {
        if (!dataAddC["Nome"] || !dataAddC["DurataManutenzione"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/addCategoria", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    Nome: dataAddC["Nome"],
                    Descrizione: dataAddC["Descrizione"],
                    DurataManutenzione: Number(dataAddC["DurataManutenzione"]),
                    IDPadre: selectedMacro
                }),
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta della tipologia", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpAddMacro = async () => {
        if (nomeMacro === "") {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/addCategoria", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    Nome: nomeMacro,
                    Descrizione: null,
                    DurataManutenzione: null,
                    IDPadre: null
                }),
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta della macro-categoria", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleEliminaS = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('/eliminaStato', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], ID: dataRowS.value["ID"] })
                });

                if (response.status === 200) {
                    window.location.reload(true);
                }
                else {
                    const data = await response.json();
                    console.log(data.error);
                    setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Operazione fallita, riprova più tardi.", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare questo stato?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmPopUpModificaS = async () => {
        if (!dataRowS.value["Nome"] || !dataRowS.value["Colore"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/aggiornaStato", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    ID: dataRowS.value["ID"],
                    Nome: dataRowS.value["Nome"],
                    Colore: dataRowS.value["Colore"]
                }),
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella modifica dello stato", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const confirmPopUpAddS = async () => {
        if (!dataAddS["Nome"] || !dataAddS["Colore"]) {
            setAlertInfo({ type: "warning", text: "Compila tutti i campi obbligatori (*)", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch("/addStato", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    Nome: dataAddS["Nome"],
                    Colore: dataAddS["Colore"]
                })
            });

            if (response.status === 500) {
                const data = await response.json();
                console.log(data.error);
                setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta dello stato", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"CATEGORIE E STATI"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 divide-y-4 divide-x-0 md:divide-y-0 md:divide-x-4 divide-gray-200 dark:divide-neutral-800 mt-2">
                    <div className="px-2 pb-2">
                        <div className="flex justify-center items-center py-1 font-semibold">CATEGORIE</div>
                        <div className="flex justify-center items-center py-1">
                            <Combobox
                                options={macroC.map((m) => ({ label: m.Nome, value: m.ID }))}
                                onChange={(value) => { setSelectedMacro(value); document.cookie = `PreselectMacro=${value}; path=/`; }}
                                label='Macro-Categoria'
                                classes="w-[70%] md:w-[50%]"
                                defaultValue={selectedMacro}
                            />
                            <Plus size={28} strokeWidth={2} className="ms-1 text-blue-600 hover:cursor-pointer" onClick={() => setIsAddMacroVisible(true)} />
                        </div>
                        <PopUp title={"Aggiungi Macro-Categoria"}
                            isVisible={isAddMacroVisible}
                            setIsVisible={setIsAddMacroVisible}
                            needConfirm={true}
                            confirmAction={confirmPopUpAddMacro}
                            cancelAction={() => setIsAddMacroVisible(false)}
                        >
                            <div className="flex flex-col items-center">
                                <Input
                                    label="Nome *"
                                    value={nomeMacro}
                                    setValue={(val) => { setNomeMacro(val) }}
                                    type="text"
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                />
                            </div>
                        </PopUp>
                        {selectedMacro && (
                            <>
                                <Table
                                    headers={headersC}
                                    keyForPreview={["Nome", "DurataManutenzione"]}
                                    data={dataC}
                                    setData={setDataC}
                                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCC data={rowData} />}
                                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                    itemsPC={7}
                                    itemsMobile={3}
                                    needResearch={true}
                                    clickableRow={true}
                                    archiveClickable={false}
                                    actionRow={(row, rowIndex) => { setDataRowC(row); console.log("Row clicked:", row); setIsRowCInfoVisible(true); }}
                                    classes="mt-2"
                                    needAdd={true}
                                    addAction={() => setIsAddCVisible(true)}
                                    needArchive={true}
                                    archiveKey="Obsoleta"
                                    archiveValue={true}
                                />
                                <PopUp title={"Aggiungi Categoria"}
                                    isVisible={isAddCVisible}
                                    setIsVisible={setIsAddCVisible}
                                    needConfirm={true}
                                    confirmAction={confirmPopUpAddC}
                                    cancelAction={() => setIsAddCVisible(false)}
                                >
                                    <div className="flex flex-col items-center">
                                        <Input
                                            label="Nome *"
                                            value={dataAddC ? dataAddC["Nome"] : ""}
                                            setValue={(val) => { setDataAddC({ ...dataAddC, "Nome": val }) }}
                                            type="text"
                                            classes="w-[80%] md:w-[70%] mt-2"
                                            disabled={false}
                                            error={false}
                                        />
                                        <Input
                                            label="Descrizione"
                                            value={dataAddC ? dataAddC["Descrizione"] : ""}
                                            setValue={(val) => { setDataAddC({ ...dataAddC, "Descrizione": val }) }}
                                            type="text"
                                            classes="w-[80%] md:w-[70%] mt-2"
                                            disabled={false}
                                            error={false}
                                        />
                                        <Input
                                            label="Durata Manutenzione (mesi) *"
                                            value={dataAddC ? dataAddC["DurataManutenzione"] : ""}
                                            setValue={(val) => { setDataAddC({ ...dataAddC, "DurataManutenzione": val }) }}
                                            type="number"
                                            classes="w-[80%] md:w-[70%] mt-2"
                                            disabled={false}
                                            error={false}
                                        />
                                    </div>
                                </PopUp>
                                <PopUp title={needConfirmRowC ? "Modifica Categoria" : ""}
                                    isVisible={isRowCInfoVisible}
                                    setIsVisible={setIsRowCInfoVisible}
                                    needConfirm={needConfirmRowC}
                                    confirmAction={confirmPopUpModificaC}
                                    cancelAction={() => { setNeedConfirmRowC(false); }}
                                >
                                    {needConfirmRowC && (
                                        <div className="flex flex-col items-center">
                                            <Input
                                                label="Nome *"
                                                value={dataRowC.value["Nome"]}
                                                setValue={(val) => { setDataRowC({ ...dataRowC, value: { ...dataRowC.value, "Nome": val } }) }}
                                                type="text"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                            />
                                            <Input
                                                label="Descrizione"
                                                value={dataRowC.value["Descrizione"]}
                                                setValue={(val) => { setDataRowC({ ...dataRowC, value: { ...dataRowC.value, "Descrizione": val } }) }}
                                                type="text"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                            />
                                            <Input
                                                label="Durata Manutenzione (mesi) *"
                                                value={dataRowC.value["DurataManutenzione"]}
                                                setValue={(val) => { setDataRowC({ ...dataRowC, value: { ...dataRowC.value, "DurataManutenzione": val } }) }}
                                                type="number"
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                disabled={false}
                                                error={false}
                                            />
                                            <Combobox
                                                options={macroC.map((m) => ({ label: m.Nome, value: m.ID }))}
                                                onChange={(value) => { setDataRowC({ ...dataRowC, value: { ...dataRowC.value, "IDPadre": value } }) }}
                                                label='Macro-Categoria *'
                                                classes="w-[80%] md:w-[70%] mt-2"
                                                defaultValue={dataRowC.value['IDPadre']}
                                            />
                                        </div>
                                    )}
                                    {!needConfirmRowC && (
                                        <>
                                            <div className="grid grid-cols-2 mt-2 gap-2">
                                                <Button type="hollow" onClick={handleEliminaC}>
                                                    ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                                </Button>
                                                <Button type="hollow" onClick={() => { setNeedConfirmRowC(true)}}>
                                                    MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                                </Button>
                                            </div>
                                        </>
                                    )}
                                </PopUp>
                            </>
                        )}
                    </div>
                    <div className="px-2 pb-2">
                        <div className="flex justify-center items-center py-1 font-semibold">STATI</div>
                        <Table
                            headers={headersS}
                            keyForPreview={["Nome"]}
                            data={dataS}
                            setData={setDataS}
                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCS data={rowData} />}
                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                            itemsPC={7}
                            itemsMobile={3}
                            needResearch={true}
                            clickableRow={true}
                            archiveClickable={false}
                            actionRow={(row, rowIndex) => { setDataRowS(row); setIsRowSInfoVisible(true) }}
                            classes="mt-2"
                            needAdd={true}
                            addAction={() => setIsAddSVisible(true)}
                            needArchive={true}
                            archiveKey="Obsoleto"
                            archiveValue={true}
                        />
                        <PopUp title={"Aggiungi stato"}
                            isVisible={isAddSVisible}
                            setIsVisible={setIsAddSVisible}
                            needConfirm={true}
                            confirmAction={confirmPopUpAddS}
                            cancelAction={() => setIsAddSVisible(false)}
                        >
                            <div className="flex flex-col items-center">
                                <Input
                                    label="Nome *"
                                    value={dataAddS ? dataAddS["Nome"] : ""}
                                    setValue={(val) => { setDataAddS({ ...dataAddS, "Nome": val }) }}
                                    type="text"
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                />
                                {/* <Input
                                    label="Stato *"
                                    value={dataAddS ? dataAddS["Stato"] : ""}
                                    setValue={(val) => { setDataAddS({ ...dataAddS, "Stato": val }) }}
                                    type="text"
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                /> */}
                                <ColorPicker
                                    label="Colore *"
                                    value={dataAddS ? dataAddS["Colore"] : ""}
                                    setValue={(val) => { setDataAddS({ ...dataAddS, "Colore": val }) }}
                                    classes="w-[80%] md:w-[70%] mt-2"
                                    disabled={false}
                                    error={false}
                                />
                            </div>
                        </PopUp>
                        <PopUp title={needConfirmRowS ? "Modifica stato" : ""}
                            isVisible={isRowSInfoVisible}
                            setIsVisible={setIsRowSInfoVisible}
                            needConfirm={needConfirmRowS}
                            confirmAction={confirmPopUpModificaS}
                            cancelAction={() => { setNeedConfirmRowS(false); }}
                        >
                            {needConfirmRowS && (
                                <div className="flex flex-col items-center">
                                    <Input
                                        label="Nome *"
                                        value={dataRowS.value["Nome"]}
                                        setValue={(val) => { setDataRowS({ ...dataRowS, value: { ...dataRowS.value, "Nome": val } }) }}
                                        type="text"
                                        classes="w-[80%] md:w-[70%] mt-2"
                                        disabled={true}
                                        error={false}
                                    />
                                    <ColorPicker
                                        label="Colore *"
                                        value={dataRowS.value["Colore"]}
                                        setValue={(val) => { setDataRowS({ ...dataRowS, value: { ...dataRowS.value, "Colore": val } }) }}
                                        classes="w-[80%] md:w-[70%] mt-3"
                                        disabled={false}
                                        error={false}
                                    />
                                </div>
                            )}
                            {!needConfirmRowS && (
                                <>
                                    <div className="grid grid-cols-2 mt-2 gap-2">
                                        <Button type="hollow" onClick={handleEliminaS}>
                                            ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                        <Button type="hollow" onClick={() => setNeedConfirmRowS(true)}>
                                            MODIFICA <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                    </div>
                                </>
                            )}
                        </PopUp>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default CategorieStati;